export default __webpack_public_path__ + "static/images/5bc57c5197169b5e44bdf997a0f791e4.png";